@if ((permissions.GET_AFTER_EFFECTS_PROJECT_FILE | userIsAllowedTo)) {
    <div class="image">
        <img [src]="afterEffectsProjectFileComposition?.files.preview?.url || 'assets/images/icon_after_effects_image.svg'"/>
    </div>
} @else {
    <no-permission-state-component/>
}
